// removed by extract-text-webpack-plugin
module.exports = {"container":"b8a7","wrapper":"_27YO","light":"_2rUs","gray":"_2XOh","positionContainer":"_2xqA","ie":"_3J2S","title":"_2N5H"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AvailablePositions/styles.scss
// module id = 420
// module chunks = 0